import { HelpersService } from "../../../services/Helpers";
import { StageColorsMapping } from "../../../pages/Admin/LeadsManagement/shared/Constants";
import { StatusChip, StatusChipTone } from "./StatusChip";
import { ChipProps } from "@mui/material/Chip";

type StageStatusChipProps = Omit<ChipProps, "color" | "label"> & {
  status?: string | null;
  label?: string;
  /** When set, chip is clickable (e.g. filter toolbar). */
  selected?: boolean;
};

/**
 * Renders a lead/attorney/extension stage as a StatusChip using StageColorsMapping.
 */
export function StageStatusChip({
  status,
  label,
  selected,
  onClick,
  sx,
  ...props
}: StageStatusChipProps) {
  const tone = (status
    ? StageColorsMapping[status as keyof typeof StageColorsMapping]
    : undefined) as StatusChipTone | undefined;

  const display =
    label ??
    (status ? HelpersService.camelToString(status) : "—");

  return (
    <StatusChip
      tone={tone ?? "neutral"}
      label={display}
      onClick={onClick}
      sx={{
        cursor: onClick ? "pointer" : "default",
        opacity: selected === false ? 0.55 : 1,
        outline: selected ? "2px solid rgba(27, 30, 51, 0.18)" : "none",
        outlineOffset: 1,
        ...sx,
      }}
      {...props}
    />
  );
}

export default StageStatusChip;
